import { render } from "./HowSigningWorks.vue?vue&type=template&id=7182fcb6&scoped=true"
import script from "./HowSigningWorks.vue?vue&type=script&lang=js"
export * from "./HowSigningWorks.vue?vue&type=script&lang=js"

import "./HowSigningWorks.vue?vue&type=style&index=0&id=7182fcb6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7182fcb6"]])

export default __exports__